import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import { IncidentContext } from './ReportIncident'

const Step4 = () => {
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)
  const [vehicleInvolved, setVehicleInvolved] = useState(
    formValues?.vehicleInvolvedBoolean ?? ''
  )
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [selectedVehicles, setSelectedVehicles] = useState(
    formValues?.selectedVehicles ?? []
  )

  useEffect(() => {
    API.get('/vehicleList')
      .then((res) => {
        setVehicleOptions(res.data)
      })
      .catch(() => setVehicleOptions([]))
  }, [])

  const handlePrevious = () => {
    setFormValues((prev) => ({
      ...prev,
      vehicleInvolvedBoolean: vehicleInvolved,
      selectedVehicles,
    }))
    setTab((prev) => prev - 1)
    window.scrollTo(0, 0)
  }
  const handleNext = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      vehicleInvolvedBoolean: vehicleInvolved,
      selectedVehicles,
    }))
    setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      component="form"
      onSubmit={handleNext}
    >
      <Typography variant="title2" fontSize="1rem">
        Vehicles
      </Typography>
      <FormControl>
        <InputLabel id="vehicleInvolved-label">
          Were any vehicles involved in the Incident?
        </InputLabel>
        <Select
          labelId="vehicleInvolved-label"
          id="vehicleInvolved"
          value={vehicleInvolved}
          label="Was any other person involved in the Incident?"
          onChange={(event) => setVehicleInvolved(event.target.value)}
          required
        >
          <MenuItem value="No">No</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
        </Select>
      </FormControl>
      {vehicleInvolved === 'Yes' && (
        <Autocomplete
          multiple
          options={vehicleOptions}
          value={vehicleOptions.filter((v) => selectedVehicles.includes(v._id))}
          onChange={(e, newValue) =>
            setSelectedVehicles(newValue.map((v) => v._id))
          }
          getOptionLabel={(opt) => opt.callSign}
          isOptionEqualToValue={(o, v) => o._id === v._id}
          renderInput={(params) => (
            <TextField {...params} label="Vehicles Involved" />
          )}
        />
      )}
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handlePrevious()}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step4
